import { Eye } from "lucide-react";
import { Button } from "primereact/button";
import Template1Img1 from "../assets/images/Insurance Template - 1.svg";
import Template1Img4 from "../assets/images/Insurance Template - 4.svg";
import Template1Img6 from "../assets/images/Insurance Template - 6.svg";
import Template1Img7 from "../assets/images/Insurance Template - 7.svg";
import Template1Img8 from "../assets/images/Insurance Template - 8.svg";
import Template1Img9 from "../assets/images/Insurance Template - 9.svg";

// import Template2Img1 from "../assets/images/Insurance-template2-img1.png";
import Template2Img1 from "../assets/images/image (11).png";
import Template2Img2 from "../assets/images/Insurance-template2-img2.png";
import Template2Img3 from "../assets/images/Insurance-template2-img3.png";
import Template2Img4 from "../assets/images/Insurance-template2-img4.png";
import Template2Img5 from "../assets/images/Insurance-template2-img5.png";
import Template2Img6 from "../assets/images/Insurance-template2-img6.png";

import Template3Img1 from "../assets/images/Insurance-template3-img1.png";
import Template4Img1 from "../assets/images/Insurance-template4-img1.png";

import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { Galleria } from "primereact/galleria";

export default function TemplateStep(props: any) {
  const [showTemplate1Images, setShowTemplate1Images] = useState(false);
  const [showTemplate2Images, setShowTemplate2Images] = useState(false);

  const [template1Data, setTemplate1Data] = useState([Template1Img1, Template1Img4, Template1Img6, Template1Img8, Template1Img9, Template1Img7]);
  const [template2Data, setTemplate2Data] = useState([Template2Img1, Template2Img2, Template2Img3, Template2Img4, Template2Img5, Template2Img6]);

  const onTemplateOnePreviewClick = () => {
    setShowTemplate1Images(true);
  };
  const onTemplateTwoPreviewClick = () => {
    setShowTemplate2Images(true);
  };
  const templateData = [
    {
      id: 1,
      img: Template1Img1,
      alt: "Modern Grid",
      title: "Modern Grid",
      description: "Clean grid layout with emphasis on visuals and key metrics",
      status: "Available",
      onclick: onTemplateOnePreviewClick,
    },
    {
      id: 2,
      img: Template2Img1,
      alt: "Classic Compare",
      title: "Classic Compare",
      description: "Traditional side-by-side comparison with detailed breakdowns",
      status: "Available",
      onclick: onTemplateTwoPreviewClick,
    },
    {
      id: 3,
      img: Template3Img1,
      alt: "Visual Impact",
      title: "Visual Impact",
      description: "Image-rich design focusing on visual representation of benefits",
      status: "Coming Soon",
    },
    {
      id: 4,
      img: Template4Img1,
      alt: "Data Focus",
      title: "Data Focus",
      description: "Analytics-driven layout with charts and detailed metrics",
      status: "Coming Soon",
    },
  ];
  const itemTemplate = (item: any) => {
    return <img src={item} alt={item.alt} style={{ width: "fit-content", height: "65vh" }} />;
  };

  const thumbnailTemplate = (item: any) => {
    return <img src={item} alt={item.alt} width="50%" />;
  };

  return (
    <div className="card border-0">
      <div className=" border-bottom pb-3 px-4 pt-4">
        <h6 className="mb-1">Select Template</h6>
        <p className="text-muted mb-0 text-12">Choose proposal template</p>
      </div>

      <div className="card-body pt-4 px-4">
        <div className="row">
          {templateData.map((item: any) => (
            <div className="col-3 ">
              <div
                className={`${item.status === "Available" ? "template-img" : ""}
                  ${
                    props.selectedTemplate == item.id
                      ? "card p-3 mb-3 hover-border-primary shadow-sm transition bg-light border-purple  "
                      : "card p-3 mb-3 hover-border-primary "
                  }
                `}
                onClick={() => {
                  if (item.status === "Available") {
                    props.onTemplateSelect(item.id);
                  }
                }}
                style={{ cursor: item.status === "Available" ? "pointer" : "not-allowed" }}
              >
                <div className="position-relative ">
                  <img src={item.img} alt={item.alt} className="w-100 rounded mb-3 " style={{ height: "40vh" }} />
                  <Button
                    label="Preview"
                    onClick={item.onclick}
                    icon={<Eye size={16} className="me-2" />}
                    className="position-absolute end-0 m-2 opacity-0  transition-opacity rounded bg-light"
                    style={{ bottom: "15px" }}
                    severity="secondary"
                    text
                    raised
                  />
                </div>

                <div>
                  <h5 className="fw-semibold mb-1">{item.title}</h5>
                  <p className="text-muted small mb-0">{item.description}</p>
                </div>
                <div className="text-end">
                  <span
                    className={
                      item.status == "Available"
                        ? "badge bg-purple text-purple py-2 px-4 rounded-pill mt-1"
                        : "badge bg-secondary py-2 px-4 rounded-pill mt-1"
                    }
                  >
                    {item.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Dialog
        header="Modern Grid"
        visible={showTemplate1Images}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => {
          setShowTemplate1Images(false);
        }}
        style={{ width: "50vw" }}
      >
        <div className="row">
          <div className="col-12">
            <Galleria value={template1Data} numVisible={5} item={itemTemplate} thumbnail={thumbnailTemplate} />
          </div>
        </div>
      </Dialog>
      <Dialog
        header="Classic Compare"
        visible={showTemplate2Images}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => {
          setShowTemplate2Images(false);
        }}
        style={{ width: "50vw" }}
      >
        <div className="row">
          <div className="col-12">
            <Galleria value={template2Data} numVisible={5} item={itemTemplate} thumbnail={thumbnailTemplate} />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
